export default __webpack_public_path__ + "static/media/WarningOutline.64098514.svg";